import { usePermission } from '@tomfxs/permissions-client'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import { Entity } from 'src/routes/statistic/useStatisticParams'
import loadComponent from 'src/utils/loadMFE'
import styled from 'styled-components'

const SearchComponent = React.lazy(() => loadComponent('search', 'SearchInput'))

const StyledDiv = styled.div`
    display: 'flex';
    justify-content: center;
    align-items: center;
    padding: 5px;
`
export function SearchInput() {
    const { academy } = useFlightDeck()
    const navigate = useNavigate()

    const onSelectResult = (entity: Entity) => {
        navigate(`search/${entity.type}/${entity._id}`)
    }

    return (
        <StyledDiv>
            {usePermission('search.view', academy ? { academy: academy._id } : {}) && <SearchComponent onSelect={onSelectResult} />}
        </StyledDiv>
    )
}
